import { render, staticRenderFns } from "./BiddersListMobileView.vue?vue&type=template&id=c630b6b6&scoped=true&"
import script from "./BiddersListMobileView.vue?vue&type=script&lang=js&"
export * from "./BiddersListMobileView.vue?vue&type=script&lang=js&"
import style0 from "./BiddersListMobileView.vue?vue&type=style&index=0&id=c630b6b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c630b6b6",
  null
  
)

export default component.exports